if (!customElements.get('ux-product-details')) {
  customElements.define(
    'ux-product-details',
    class UXProductDetails extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-product-details-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-product-details-panel]'));
        this.switchTimer = null;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event));
        });
      }

      onTabKeydown(event) {
        const currentIndex = this.tabs.indexOf(event.currentTarget);
        if (currentIndex < 0) return;

        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex], true);
      }

      activateTab(activeTab, shouldFocus = false) {
        const activePanelId = activeTab.getAttribute('aria-controls');
        const currentTab = this.tabs.find((tab) => tab.classList.contains('is-active'));
        const isChangingTab = currentTab !== activeTab;

        if (!activePanelId) return;

        if (isChangingTab) {
          clearTimeout(this.switchTimer);
          this.classList.add('is-switching');
        }

        this.tabs.forEach((tab) => {
          const isActive = tab === activeTab;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== activePanelId;
        });

        if (shouldFocus) activeTab.focus();

        if (isChangingTab) {
          this.switchTimer = setTimeout(() => {
            this.classList.remove('is-switching');
          }, 260);
        }
      }
    }
  );
}
